import React, { useState, useRef, useEffect } from "react";

export default function InsightsDropdown({ showInsight, setShowInsight }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={menuRef}>
      <button
        type="button"
        className={`flex items-center gap-2 px-4 py-2 rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200 transition`}
        onClick={() => setOpen((prev) => !prev)}
      >
        {/* Icon: Replace with your own SVG if needed */}
        <i className="fa-solid fa-chart-simple"></i>
        <span className="font-semibold text-sm md:hidden lg:block">
          Insights
        </span>
        {/* Caret Icon */}
        <svg
          className={`w-4 h-4 ml-1 transition-transform ${
            open ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            d="M6 8l4 4 4-4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {open && (
        <div className="absolute left-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-20">
          <button
            onClick={() => setShowInsight(!showInsight)}
            className="flex items-center w-full px-4 py-2 text-sm text-gray-900 hover:bg-gray-50 rounded-t-lg transition"
          >
            {/* Checkmark Icon */}
            {showInsight && (
              <svg
                className="w-4 h-4 mr-2 text-gray-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  d="M5 10l4 4 6-6"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
            Show stats panel
          </button>
          <button className="w-full px-4 py-2 text-sm text-gray-900 hover:bg-gray-50 rounded-b-lg transition text-left">
            Give feedback
          </button>
        </div>
      )}
    </div>
  );
}
